export default __webpack_public_path__ + "static/media/41_desktop.c305c5dc.jpg";